/**
 *  @file       resource-dir.js
 *  @author     Ryan Rossiter, ryan@kingsds.network
 *  @date       March 2020
 *  @author     Wes Garland, wes@distributive.netework
 *  @date       March 2024
 *
 * This module is a utility for resolving the resourceDir,
 * the user's configuration directory, which is usually
 * located at ~/.dcp
 *
 * This module delays calculations as late as possible, so that the home and/or dot directories can be
 * changed by the calling program. API consumers should invoke the get() APIs every time a directory is
 * needed, instead of caching the result, so that the changes take effect properly.
 *
 * The environment variable DCP_RESOURCE_DIR can be used to override this directoryn.
 *
 * We use `XDG_DATA_HOME` as the home directory if it is set. If it is not set, we
 * default to ~. If the home directory matches `XDG_DATA_HOME`, we use dcp instead of .dcp (omitting
 * the period) as the basename for resourceDir. This deviates from the XDG Base Directory Spec.
 *
 */
'use strict';
const dcpEnv = require('dcp/common/dcp-env');
const fsBasic = require('dcp/common/fs-basic');
const { requireNative } = require('dcp/dcp-client/webpack-native-bridge');

var overrideResourceDir;
const resourceDir$$setResourceDir = (dir) => { overrideResourceDir = require('dcp/utils').expandPath(dir) };

function resourceDir$$getResourceDir()
{
  var resourceDir = overrideResourceDir;

  if (resourceDir)
    return resourceDir;
  
  resourceDir = dcpEnv.getenv('DCP_RESOURCE_DIR');
  
  if (resourceDir)
    return resourceDir;

  let home;
  let dcpDir = 'dcp';
  
  if (dcpEnv.getenv('XDG_DATA_HOME'))
    home = dcpEnv.getenv('XDG_DATA_HOME');
  else
  {
    switch (dcpEnv.platform)
    {
      case 'nodejs':
      {
        const os = requireNative('os');
        home = os.homedir();
        break;
      }
      case 'pythonmonkey':
      {
        home = globalThis.python.eval('__import__("os").path.expanduser("~")');
        break;
      }
      default:
        throw new Error('unable to determine home directory');
    }
    dcpDir = '.' + dcpDir;
  }
  resourceDir = fsBasic.joinPath(home, dcpDir);

  return resourceDir;
}

if (!dcpEnv.isBrowserPlatform)
{
  exports.getResourceDir = resourceDir$$getResourceDir;
  exports.setResourceDir = resourceDir$$setResourceDir;
}
